import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    container: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
    asideContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      gap: "24px",
    },
    mainContent: {
      display: "flex",
      justifyContent: "space-between",
      gap: "24px",
      marginTop: "12px",
    },
    tabWrapper: {
      flexBasis: "73%",
    },
    aedIcon: {
      verticalAlign: "super",
      fill: theme.palette.text.tertiary,
    },
    summeryText: {
      color: theme.palette.text.primary,
      fontSize: "30px",
      fontWeight: 600,
    },
    roi: {
      color: theme.palette.text.tertiary,
      fontSize: "30px",
      fontWeight: 600,
    },
    success: {
      color: theme.palette.text.success_primary,
      fontSize: "30px",
      fontWeight: 600,
    },
    error: {
      color: theme.palette.text.error_primary,
      fontSize: "30px",
      fontWeight: 600,
    },
    summeryTitle: {
      color: theme.palette.text.tertiary,
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "24px",
    },
    panelContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "32px",
      marginTop: "32px",
    },

  };
});
